import React from "react";
import { Clock, BadgeDollarSign } from "lucide-react";
import { businessInfo } from "../mock";

const CatchphraseBanner = () => {
  return (
    <section className="relative py-14 lg:py-20 fire-bg text-white overflow-hidden border-y border-red-900/40">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
          backgroundSize: "28px 28px",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <div className="inline-flex items-center gap-6 text-yellow-400 font-bold text-xs uppercase tracking-[0.4em] mb-5">
          <Clock className="w-4 h-4" />
          <span>The 1/2 Fast Promise</span>
          <BadgeDollarSign className="w-4 h-4" />
        </div>
        <blockquote className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight leading-snug">
          <span className="text-fire text-5xl leading-none align-top mr-1">&ldquo;</span>
          <span className="text-white">Getting you the keys you need in </span>
          <span className="text-fire">half the time</span>
          <span className="text-white"> and at </span>
          <span className="text-gold-shine">half the cost</span>
          <span className="text-white"> of the dealerships</span>
          <span className="text-fire text-5xl leading-none align-bottom ml-1">&rdquo;</span>
        </blockquote>
        <div className="mt-6 flex items-center justify-center gap-2 text-zinc-400 text-sm">
          <span className="h-px w-10 bg-zinc-700" />
          {businessInfo.owner} · {businessInfo.name}
          <span className="h-px w-10 bg-zinc-700" />
        </div>
      </div>
    </section>
  );
};

export default CatchphraseBanner;
